module.exports = __webpack_public_path__ + "static/media/calendar.26cea1e7.svg";